<template>
  <div class="ordinaryModify custom">
    <el-dialog :popper-append-to-body="false" :close-on-click-modal="false" :visible.sync="setFlagDialogVisible" :before-close="handleClose">
      <div class="ordinaryModifyChild">
        <div class="secBox">
          <div class="child">
            <div class="selb">
              <span class="selb-title">图片：</span>
              <img :src="optionsList.imgPath" alt="" />
            </div>
          </div>
          <div class="child">
            <div class="selb">
              <span class="selb-title">公司款号：</span>
              <span>{{ optionsList.styleNumber }}</span>
            </div>
          </div>
          <div class="child" v-if="lcTechnologList && lcTechnologList.length > 0">
            <div class="selb">
              <span class="selb-title">鎏彩工艺：</span>
              <div class="material selectBox">
                <el-radio-group v-model="amendDuplication.lcTechnology" size="small" @change="getSizeRange($event, 'lcTechnology')">
                  <span class="inchesFix">
                    <el-radio-button v-for="item in lcTechnologList" :key="item" :value="item" :label="item">{{ item }}</el-radio-button>
                  </span>
                </el-radio-group>
              </div>
            </div>
          </div>
          <div class="child" v-if="goldenWeighList && goldenWeighList.length > 0">
            <div class="selb">
              <span class="selb-title">金重：</span>
              <div class="material selectBox">
                <el-radio-group v-model="amendDuplication.goldWeigh" size="small" @change="getSizeRange($event, 'goldWeigh')">
                  <span class="inchesFix">
                    <el-radio-button v-for="item in goldenWeighList" :key="item" :value="item" :label="item">{{ item }}</el-radio-button>
                  </span>
                </el-radio-group>
              </div>
            </div>
          </div>
          <div class="child" v-if="handSizeList && handSizeList.length > 0">
            <div class="selb">
              <span class="inchesTips-size" v-if="handSizeList && handSizeList[0].includes('寸')">(1英寸＝2.54厘米)</span>
              <span class="selb-title">规格：</span>
              <div class="material selectBox">
                <el-radio-group v-model="amendDuplication.ringSize" size="small" @change="getSizeRange($event, 'ringSize')">
                  <span class="inchesFix">
                    <el-radio-button v-for="item in handSizeList" :key="item" :value="item" :label="item">{{ item }}</el-radio-button>
                  </span>
                </el-radio-group>
              </div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button :loading="btnFlag" class="modifyCart" @click.stop="last()" v-if="index != 0">返回，上一个</el-button>
        <el-button :loading="btnFlag" class="copyCart" @click.stop="next()" v-if="index != propGroupData.length - 1">确定，下一个</el-button>
        <el-button :loading="btnFlag" class="copyCart" @click.stop="addOrder" v-if="index == propGroupData.length - 1">立即下单</el-button>
        <div class="propGroupIndex">
          <span class="groupColor">{{ index + 1 }}</span
          >/{{ propGroupData.length }}
        </div>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { getOptional, getPriceRangeSpot } from '@/api/detailsApi';
import { modifyCartPublic } from '@/api/cartApi';
import { deepClone } from '@/utils/util';
import { debounce } from '@/utils/index';
import ls from '@/utils/localStorage';
export default {
  props: {
    setFlagDialogVisible: Boolean,
    // modifyingReplication: {
    //   type: Object,
    //   default() {
    //     return {};
    //   },
    // },
    addCartOrder: {
      type: Object,
      default() {
        return {};
      },
    },
    propGroupData: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      optionsList: {},
      amendDuplication: {
        lcTechnology: '',
        goldWeigh: '',
        ringSize: '',
        lcTechnologyIndex: 0,
        goldWeighIndex: 0,
      },
      btnFlag: false,
      goldenWeighList: [],
      handSizeList: [],
      lcTechnologList: [],
      index: 0,
      pageData: [],
    };
  },
  mounted() {
    this.getOptional(0);
  },
  methods: {
    // 关闭弹窗
    handleClose() {
      this.$emit('onCloseSetDialog', null);
    },
    // 立即下单
    addOrder() {
      this.next('addOrder');
    },
    // 上一个
    last() {
      --this.index;
      this.echo();
      this.getOptional(this.index);
    },
    // 下一个
    next(addOrder) {
      if (
        (this.lcTechnologList.length > 0 && !this.amendDuplication.lcTechnology) ||
        !this.amendDuplication.goldWeigh ||
        (this.handSizeList.length > 0 && !this.amendDuplication.ringSize)
      ) {
        return this.$message({
          message: '请选择参数',
          type: 'warning',
          duration: 500,
        });
      }
      const obj = {
        ...this.amendDuplication,
        index: this.index,
        shopType: this.addCartOrder.shopType,
        quantity: this.addCartOrder.productDtoList[0]?.quantity,
        ...this.optionsList,
      };
      if (!this.pageData[this.index]) {
        this.pageData.push(obj);
      } else {
        this.pageData[this.index] = obj;
      }
      if (addOrder) {
        return this.$emit('onCloseSetDialog', this.pageData);
      }
      ++this.index;
      this.echo();
      this.getOptional(this.index);
    },
    defaultSelected() {
      if (this.optionsList.lcTechnologyFlag == 1) {
        if (this.lcTechnologList.length == 1) {
          this.amendDuplication.lcTechnology = this.lcTechnologList[0];
        }
        if (this.lcTechnologList.length == 0) this.amendDuplication.lcTechnology = '';
        if (this.goldenWeighList.length == 1) {
          this.amendDuplication.goldWeigh = this.goldenWeighList[0];
        }
        if (this.goldenWeighList.length == 0) this.amendDuplication.goldWeigh = '';
        if (this.handSizeList.length == 1) {
          this.amendDuplication.ringSize = this.handSizeList[0];
        }
        if (this.handSizeList.length == 0) this.amendDuplication.ringSize = '';
      } else {
        if (this.goldenWeighList.length == 1) {
          this.amendDuplication.goldWeigh = this.goldenWeighList[0];
        }
        if (this.goldenWeighList.length == 0) this.amendDuplication.goldWeigh = '';
        if (this.handSizeList.length == 1) {
          this.amendDuplication.ringSize = this.handSizeList[0];
        }
        if (this.handSizeList.length == 0) this.amendDuplication.ringSize = '';
      }
    },
    echo() {
      if (this.pageData[this.index]) {
        this.amendDuplication.lcTechnology = this.pageData[this.index].lcTechnology; //当前选中的流彩
        this.amendDuplication.goldWeigh = this.pageData[this.index].goldWeigh; //当前选中的金重
        this.amendDuplication.ringSize = this.pageData[this.index].ringSize; //当前选中的手寸
        this.amendDuplication.lcTechnologyIndex = this.pageData[this.index].lcTechnologyIndex;
        this.amendDuplication.goldWeighIndex = this.pageData[this.index].goldWeighIndex; //当前选中的手寸
      } else {
        this.clear();
      }
      // this.defaultSelected();
    },
    clear() {
      this.amendDuplication.lcTechnology = ''; //当前选中的流彩
      this.amendDuplication.goldWeigh = ''; //当前选中的金重
      this.amendDuplication.ringSize = ''; //当前选中的手寸
      this.amendDuplication.lcTechnologyIndex = 0;
      this.amendDuplication.goldWeighIndex = 0;
    },
    // 金重排序
    mainStoneSort(list) {
      // 1. 将每个区间字符串解析为对象
      const parsedRanges = list?.map((range) => {
        const [start, end] = range.split('-').map(parseFloat);
        return { start, end, range }; // 保留原始字符串以便最后恢复
      });
      // 2. 根据 start 值进行排序
      parsedRanges.sort((a, b) => a.start - b.start);
      // 3. 提取排序后的原始字符串
      return parsedRanges.map((item) => item.range);
    },
    // 规格重新排序
    sortFun(handSizeList) {
      return handSizeList?.sort(function (a, b) {
        return a - b;
      });
    },
    // 组装数据
    getOptional(index) {
      this.optionsList = this.propGroupData[index];
      if (this.optionsList.lcTechnologyFlag == 1) {
        this.lcTechnologList = Object.keys(this.optionsList.handSizeMap);
        this.goldenWeighList = this.mainStoneSort(Object.keys(Object.values(this.optionsList.handSizeMap)[this.amendDuplication.lcTechnologyIndex]));
        this.handSizeList = this.sortFun(
          Object.values(Object.values(Object.values(this.optionsList.handSizeMap)[this.amendDuplication.lcTechnologyIndex]))[
            this.amendDuplication.goldWeighIndex
          ]
        );
      } else {
        this.lcTechnologList = [];
        this.goldenWeighList = this.mainStoneSort(Object.keys(this.optionsList.handSizeMap));
        this.handSizeList = this.sortFun(Object.values(this.optionsList.handSizeMap)[this.amendDuplication.goldWeighIndex]);
      }
      this.defaultSelected();
    },
    getSizeRange(value, type) {
      this.amendDuplication[type] = value;
      if (this.optionsList.lcTechnologyFlag == 1) {
        if (type === 'lcTechnology') {
          this.amendDuplication.lcTechnologyIndex = this.lcTechnologList.indexOf(value);
          this.goldenWeighList = this.mainStoneSort(
            Object.keys(Object.values(this.optionsList.handSizeMap)[this.amendDuplication.lcTechnologyIndex])
          );
          this.handSizeList = this.sortFun(
            Object.values(Object.values(Object.values(this.optionsList.handSizeMap)[this.amendDuplication.lcTechnologyIndex]))[
              this.amendDuplication.goldWeighIndex
            ]
          );
          this.amendDuplication.goldWeigh = '';
          this.amendDuplication.ringSize = '';
          this.amendDuplication.goldWeighIndex = 0;
        }
        if (type === 'goldWeigh') {
          this.amendDuplication.goldWeighIndex = this.goldenWeighList.indexOf(value);
          this.handSizeList = this.sortFun(
            Object.values(Object.values(Object.values(this.optionsList?.handSizeMap)[this.amendDuplication.lcTechnologyIndex]))[
              this.amendDuplication.goldWeighIndex
            ]
          );
          this.amendDuplication.ringSize = '';
        }
      } else {
        if (type === 'goldWeigh') {
          this.amendDuplication.goldWeighIndex = this.goldenWeighList.indexOf(value);
          this.handSizeList = this.sortFun(Object.values(this.optionsList.handSizeMap)[this.amendDuplication.goldWeighIndex]);
          this.amendDuplication.ringSize = '';
        }
      }
      this.defaultSelected();
    },
  },
};
</script>

<style scoped lang="scss">
.ordinaryModify {
  ::v-deep .el-dialog {
    width: 900px;
  }

  ::v-deep .el-dialog__body {
    padding-top: 0;
  }

  .ordinaryModifyChild {
    display: flex;
  }

  ::v-deep .el-select > .el-input {
    width: 300px;
  }

  .secBox {
    width: 100%;
  }

  .remorkBox {
    margin-top: 25px !important;
  }

  .child {
    display: flex;
    justify-content: space-between;
    margin: 10px 0;
    img {
      width: 200px;
      height: 200px;
    }
    .selb {
      // height: 40px;
      // line-height: 40px;
      display: flex;
      align-items: center;
      position: relative;
      // width: 400px;

      .el-radio-group {
        // margin-left: 20px;
      }

      ::v-deep .el-radio__input.is-checked .el-radio__inner {
        border-color: #ec9368;
        background: #ec9368;
      }

      ::v-deep .el-radio__input.is-checked + .el-radio__label {
        color: #ec9368;
      }

      span {
        font-size: 14px;
        display: inline-block;
        margin-right: 5px;
        min-width: 70px;
      }
      .selb-title {
        text-align: right;
      }
    }
  }

  ::v-deep .el-dialog__headerbtn .el-dialog__close {
    font-size: 24px;
  }

  ::v-deep .el-dialog__headerbtn {
    top: 5px;
    right: 5px;
  }
}

::v-deep .el-select-dropdown__item {
  padding: 0;
  height: auto;
}

::v-deep .el-select-dropdown__list {
  display: flex;
  width: 300px;
  flex-wrap: wrap;
}

::v-deep .el-input__inner {
  color: #ec9368;
}

::v-deep .el-select-dropdown__item.hover,
.el-select-dropdown__item:hover {
  background: #fff;
}

::v-deep .el-input-number {
  width: 300px;
}

::v-deep .el-icon-minus {
  font-size: 14px;
  color: #ec9368;
}

::v-deep .el-icon-plus {
  font-size: 14px;
  color: #ec9368;
}

::v-deep .el-textarea__inner {
  width: 760px;
}

::v-deep .el-dialog__footer {
  text-align: center;
}

::v-deep .el-button span {
  font-size: 14px;
}

.modifyCart {
  background: #87ceeb;
  color: #fff;
  border: none;
}

.copyCart {
  background: #ec9368;
  color: #fff;
  border: none;
  margin-left: 20px;
}

.el-button.is-disabled,
.el-button.is-disabled:focus,
.el-button.is-disabled:hover {
  color: #c0c4cc;
  cursor: not-allowed;
  background-image: none;
  background-color: #fff;
  border: 1px solid #ebeef5;
}
.custom {
  .fx {
    position: relative;
    margin: 8px 0;
  }

  .fl {
    display: flex;
    align-items: center;
    position: relative;
  }

  .selectBox {
    ::v-deep .el-popper {
      left: 0 !important;
    }

    .el-scrollbar__view li {
      width: 178px;
    }
  }

  .selectBoxWatch {
    .el-scrollbar__view li {
      min-width: 90px;
    }
  }
  .inchesFix {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }
  .inchesTips {
    color: red;
    font-size: 12px;
    margin-left: 8px;
  }
  .inchesTips-size {
    color: red;
    font-size: 12px !important;
    margin-left: 8px;
    position: absolute;
    top: 37px;
    left: 20px;
  }
  .material {
    // width: 800px;
    ::v-deep .el-radio-button__inner {
      min-width: 65px;
    }
  }
  ::v-deep .el-radio-button__orig-radio:checked + .el-radio-button__inner {
    color: #fff;
    background-color: #ec9368;
    border-color: #ec9368;
    box-shadow: none;
  }
  ::v-deep.el-radio-button__inner:hover {
    color: rgb(236, 147, 104);
  }
  ::v-deep .el-radio-button__inner {
    margin: 5px;
    border-left: 1px solid #dcdfe6;
    border-radius: 4px;
  }
  ::v-deep .inchesFix:first-child .el-radio-button__inner {
    margin-left: 0;
  }
  ::v-deep .el-radio-group {
    display: flex;
    flex-wrap: wrap;
  }
  .propGroupIndex {
    margin: 20px 0 0 0;
  }
}
</style>
